import { rootEventBus, EnumRootEventBus } from "./RootEventBus";
import PointTag from "../entities/PointTag";
import { Coord } from "../types/Interface";
import generatePoints from "../utils/generator/generatePoints";


export default class BasePointTagManager {
  private cCoord: Coord;
  private center = new PointTag("O");
  private tags: PointTag[] = [];

  constructor(cCoord: Coord, tags: string[]) {
    this.cCoord = cCoord;
    this.tags = tags.map(tag => new PointTag(tag));
    this.updateCenter();

    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
  }

  updateCenter = () => this.center.updateCoord({ x: this.cCoord.x + 21, y: this.cCoord.y + 21 })
  setAllVisible = (visible: boolean) => [this.center, ...this.tags].forEach(pTag => pTag.visible = visible);

  updateCoord(radians: number[], radius: number) {
    const coords = generatePoints(this.cCoord, radians, radius + 30)
    coords.forEach((coord, cI) => this.tags[cI].updateCoord(coord));
  }
}